/**
 * setInterval alternative to completely pause all updates when window is not in focus
 * Some browsers do pause, some do not, and yet others pause but then rush to keep up.
 * This implementation pauses all intervals, and then will call them once only if they have waited too long, when it comes back.
 *
 * NOTE: API is consistent with setInterval (milliseconds), however this implementation only has a granularity of 1 second, because it collects the callbacks
 * and executes them together.
 *
 * Add a callback every second:
 *     IntervalManager.setInterval(callback, 1 * IntervalManager.SECOND);
 *
 * Add callback every 30 seconds, then remove callback:
 *     var id = IntervalManager.setInterval(callback, 30 * IntervalManager.SECONDS);
 *     IntervalManager.clearInterval(id);
 *
 */

define('all/interval-manager',[],function() {
	'use strict';

	var uniqueId = 1;
	var intervals = {};

	var IntervalManager = window.IntervalManager = {};

	IntervalManager.SECOND = IntervalManager.SECONDS = 1000;
	IntervalManager.MINUTE = IntervalManager.MINUTES = 60 * IntervalManager.SECONDS;
	IntervalManager.HOUR = IntervalManager.HOURS = 60 * IntervalManager.MINUTES;

	var isTabActive = (function() {
		var hidden;
		if (typeof document.hidden !== 'undefined') {
			hidden = 'hidden';
		} else if (typeof document.mozHidden !== 'undefined') {
			hidden = 'mozHidden';
		} else if (typeof document.msHidden !== 'undefined') {
			hidden = 'msHidden';
		} else if (typeof document.webkitHidden !== 'undefined') {
			hidden = 'webkitHidden';
		}

		if (hidden) {
			return function() {
				return !document[hidden];
			};
		}

		return function() {
			return document.hasFocus();
		};

	}());

	IntervalManager.setInterval = function(callback, delay) {
		if (typeof callback === 'string') {
			throw new Error('Named functions are not allowed (because eval is evil), use a real callback!');
		}

		if(delay % 1000 !== 0) {
			console.warn('IntervalManager does not support any other precision than 1 second, delay not divisible with 1000:', delay);
		}

		var intervalId = uniqueId++;
		intervals[intervalId] = new Interval(callback, delay, Array.prototype.slice.call(arguments, 2));
		return intervalId;
	};

	IntervalManager.clearInterval = function(intervalId) {
		delete intervals[intervalId];
	};

	function Interval(callback, delay, args) {
		this.callback = callback;
		this.delay = delay;
		this.args = args;
		this.lastExecuted = Date.now();
	}

	Interval.prototype.call = function() {
		var now = Date.now();
		if (now - this.lastExecuted >= this.delay) {
			this.callback.apply(this, this.args);
			this.lastExecuted = now;
		}
	};

	setInterval(intervalLoop, IntervalManager.SECOND);
	function intervalLoop() {
		if (isTabActive()) {
			for (var intervalId in intervals) {
				if (intervals.hasOwnProperty(intervalId)) {
					var intervalObject = intervals[intervalId];
					intervalObject.call();
				}
			}
		}
	}
	return IntervalManager;
});

